import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptToolsGrid, DeptReportsGrid } from '../../Components/Common/DashboardKit';

/**
 * Shipping module landing page.
 *
 * Owner (2026-10-05): the department pages list the modules the team uses and the KPI
 * reports that matter to it (DeptLandingSections); each card shows only when the person
 * may open it. The route is gated by dept.shipping in allRoutes.js.
 */
const TOOLS = ["epoShipping", "epoMissing", "epoFindByItem", "epoFind", "displayBoards", "visitors", "tasks", "epoCreate"];
const REPORTS = ["summary-otd", "blown-up-otd", "open-orders", "backlog-orders"];

const Shipping = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-truck-line"
                        eyebrow="Logistics"
                        title="Shipping"
                        subtitle="Outbound shipments, packing, and carrier tracking"
                        tone="blue"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Shipping" },
                        ]}
                    />

                    <DeptToolsGrid
                        ids={TOOLS}
                        title="Shipping tools"
                        description="EPO receiving, missing shipments, lookups and boards"
                        icon="ri-truck-line"
                    />
                    <DeptReportsGrid ids={REPORTS} />

                    <ComingSoonCard
                        compact
                        icon="ri-truck-line"
                        title="More for Shipping later"
                        message="Ideas for later: daily outbound lists, packing slips and carrier tracking. The cards above are live today."
                        tone="info"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Shipping;
